import {
  API_GET_HOST_POOL,
  API_GET_SESSION_HOST,
  API_GET_USER_SESSION,
  API_NOTIFY_USER,
} from "../ApiConstants";
import axios from "../client/rest";

class CommunicationApi {
  static sharedInstance = new CommunicationApi();

  constructor() {
    if (CommunicationApi.sharedInstance !== null) {
      return CommunicationApi.sharedInstance;
    }
  }

  async getHostPool() {
    try {
      const res = await axios.get(API_GET_HOST_POOL);
      const { data } = res;
      if (res.status === 200) {
        return data.value;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getSessionHost(body: any) {
    try {
      const { hostPool, resourceGroup } = body;
      const res = await axios.get(
        API_GET_SESSION_HOST + hostPool + "/" + resourceGroup
      );

      const { data } = res;
      if (res.status === 200) {
        return data.value;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getUserSessions(body: any) {
    try {
      const res = await axios.post(API_GET_USER_SESSION, body);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async notifyUser(body: any) {
    try {
      const res = await axios.post(API_NOTIFY_USER, body);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default CommunicationApi.sharedInstance;
